import PaymentMethodAdmin from 'src/adminPanel/entities/PaymentMethodAdmin';
import callApi, { CallApiResult } from '.';

export const fetchPaymentMethods = (): Promise<CallApiResult> => {
    return callApi(`/api/admin/paymentMethod/list`);
};

export const createNewPaymentMethod = (newPaymentMethod: PaymentMethodAdmin): Promise<CallApiResult> => {
    return callApi(`/api/admin/paymentMethod/add`, { method: 'POST', data: newPaymentMethod });
};

export const updateExistingPaymentMethod = (updatedPaymentMethod: PaymentMethodAdmin): Promise<CallApiResult> => {
    return callApi(`/api/admin/paymentMethod/update`, { method: 'PUT', data: updatedPaymentMethod });
};
